import { useTypedSelector } from '../store';

import type { Tenant } from '../api/tenants';

// Per-tenant switches for modules not every tenant gets yet. Set by a platform admin in
// the tenant's metadata: {"features": ["approvals", "analytics"]}. UI visibility only.
export const FEATURES = {
	approvals: 'Approvals',
	analytics: 'Analytics',
	role_switcher: 'Role switcher (demo only)',
} as const;

export type Feature = keyof typeof FEATURES;

export const hasFeature = (tenant: Tenant | null, feature: Feature): boolean =>
	tenant?.metadata?.features?.includes(feature) ?? false;

export const useFeature = (feature: Feature): boolean =>
	hasFeature(
		useTypedSelector((state) => state.tenant.tenant),
		feature,
	);

// The tenant update replaces the whole metadata object, so keep every other key.
export const withFeature = (
	metadata: Tenant['metadata'],
	feature: Feature,
	enabled: boolean,
): NonNullable<Tenant['metadata']> => {
	const others = (metadata?.features ?? []).filter((f) => f !== feature);
	return { ...metadata, features: enabled ? [...others, feature] : others };
};
